class BuildingEffectAmount {
    __percent;
    constructor() {
        this.__percent = -1;
    }
    increase(amount) {
        if (this.__percent === -1) {
            this.__percent = 0;
        }
        this.__percent += amount;
    }
    canAffect() {
        return this.__percent > 0;
    }
    applyTo(amount) {
        return amount * this.__percent / 100;
    }
}
export default BuildingEffectAmount;
